import { SingleShipmentQuotationResponseDto } from '../../types/single-shipment.quotation.response-dto';
import { SingleShipmentRequestDto } from '../../types/single-shipment.request-dto';

export type SingleShipmentState = {
  boxes: SingleShipmentRequestDto.Box[];
  customer: SingleShipmentRequestDto.Customer;
  declaredValue: number;
  quotation?: {
    deliveryOptionId: string;
  };
  destination: SingleShipmentRequestDto.Address;
  sender: SingleShipmentRequestDto.Address;
  invoiceKey?: string;
  fiscalInformationType: string;
  quotationsList?: SingleShipmentQuotationResponseDto;
  modalCancel?: boolean;
  enableDeliveryOption: boolean;
  modality: string;
};

export const initialState: SingleShipmentState = {
  boxes: [],
  customer: {
    name: '',
    lastName: '',
    phoneNumber: '',
    email: '',
    legalIdentification: ''
  },
  destination: {
    address: '',
    city: '',
    country: '',
    name: '',
    neighborhood: '',
    number: '',
    province: '',
    zipCode: '',
    complement: ''
  },
  sender: {
    address: '',
    city: '',
    country: '',
    name: '',
    neighborhood: '',
    number: '',
    province: '',
    zipCode: '',
    complement: ''
  },
  quotation: { deliveryOptionId: '' },
  invoiceKey: '',
  fiscalInformationType: '',
  declaredValue: 0,
  quotationsList: {
    active: [],
    disabled: []
  },
  modalCancel: false,
  enableDeliveryOption: false,
  modality: ''
};

export const SINGLE_SHIPMENT_ACTIONS = {
  SUBMIT_FORM: 'SUBMIT_FORM',
  LOAD_DELIVERY_OPTIONS: 'LOAD_DELIVERY_OPTIONS',
  SELECT_DELIVERY_OPTION: 'SELECT_DELIVERY_OPTION',
  TOGGLE_MODALITY: 'TOGGLE_MODALITY',
  CLEAR_FORM: 'CLEAR_FORM',
  OPEN_MODAL: 'OPEN_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL'
} as const;

export type Action =
  | {
      type: typeof SINGLE_SHIPMENT_ACTIONS.SUBMIT_FORM;
      payload: Partial<SingleShipmentRequestDto>;
    }
  | {
      type: typeof SINGLE_SHIPMENT_ACTIONS.LOAD_DELIVERY_OPTIONS;
      payload: SingleShipmentQuotationResponseDto;
    }
  | {
      type: typeof SINGLE_SHIPMENT_ACTIONS.SELECT_DELIVERY_OPTION;
      payload: {
        id: string;
        activateModality: boolean;
        modality: string;
      };
    }
  | {
      type: typeof SINGLE_SHIPMENT_ACTIONS.TOGGLE_MODALITY;
      payload: {
        activateModality: boolean;
        modality: string;
      };
    }
  | { type: typeof SINGLE_SHIPMENT_ACTIONS.CLEAR_FORM }
  | {
      type: typeof SINGLE_SHIPMENT_ACTIONS.OPEN_MODAL;
    }
  | {
      type: typeof SINGLE_SHIPMENT_ACTIONS.CLOSE_MODAL;
    };

export const singleShipmentReducer = (
  state: SingleShipmentState,
  action: Action
): SingleShipmentState => {
  switch (action.type) {
    case SINGLE_SHIPMENT_ACTIONS.SUBMIT_FORM:
      return { ...state, ...action.payload };

    case SINGLE_SHIPMENT_ACTIONS.LOAD_DELIVERY_OPTIONS:
      return { ...state, quotationsList: action.payload };

    case SINGLE_SHIPMENT_ACTIONS.SELECT_DELIVERY_OPTION:
      return {
        ...state,
        quotation: {
          deliveryOptionId: action.payload.id
        },
        enableDeliveryOption: action.payload.activateModality,
        modality: action.payload.modality
      };

    case SINGLE_SHIPMENT_ACTIONS.TOGGLE_MODALITY:
      return {
        ...state,
        enableDeliveryOption: action.payload.activateModality,
        modality: action.payload.modality
      };

    case SINGLE_SHIPMENT_ACTIONS.CLEAR_FORM:
      return initialState;

    case SINGLE_SHIPMENT_ACTIONS.OPEN_MODAL:
      return { ...state, modalCancel: true };

    case SINGLE_SHIPMENT_ACTIONS.CLOSE_MODAL:
      return { ...state, modalCancel: false };

    default:
      return state;
  }
};
